import { createNamespacedHelpers } from 'vuex'; 

const { 
  mapActions : acListCommMapActions , 
  mapGetters : acListCommMapGetters , 
  mapMutations : acListCommMapMutations , 
  mapState : acListCommMapState ,  
 } = createNamespacedHelpers('AcListComm');

const Common = {
  data () {
    return {
      // tagList : [] , 
    }
  } , 
  computed : {
    ...acListCommMapGetters(['srchVal','tagList']) , 

    srchValStr : {
      set ( newVal ) {
        // this.srchVal = newVal ; 
        this.setSrchVal( newVal ) ; 
      } , 
      get () {
        return this.srchVal ; 
      } , 
    } , 

    hasOpenElement () {
      return this.tagList.filter( tag => tag.status.size.open )[0] ; 
    } , 
  } , 
  watch : {
    elements () {
      // console.log( 'watch - elements : ' , this.elements ) ; 
      // this.tagList = this.elements ; 
      this.setTagList( this.elements ) ; 
    } , 
  } , 
  created () {
    
    // this.setQuery( this.$route.query ) ; 
  } , 
  mounted () {
    // this.setCrntElement( this.$el ) ; 
    // this.setCrntElement( this.$el )
    // this.$nextTick(_=> {
    // console.log( this.$el ) ; 
    // }) ; 
    /* 
    console.log( '-- all common in - this.processId : ' , this.processId ) ; 
    console.log( '-- all common in - this.editorType : ' , this.editorType ) ;  
    console.log( '-- all common in - this.protocolId : ' , this.protocolId ) ; 
    */
  } , 
  methods : {
    ...acListCommMapActions(['srchInputHandler','setSrchVal','setTagList']) , 
    
  } , 
}

export default Common ; 